import { Component, OnInit, Inject } from "@angular/core";
import { RolesSharedService } from "../../services/roles-shared.service";
import {
  FormGroup,
  FormBuilder,
  Validators,
  FormControl
} from "@angular/forms";
import { ContactForm } from "../../models/contact-form.model";
import { Constants } from "@shared/constants/app.constants";
import swal from "sweetalert2";
import { DOCUMENT } from "@angular/common";

@Component({
  selector: "app-contact-us",
  templateUrl: "./contact-us.component.html",
  styleUrls: ["./contact-us.component.css"]
})
export class ContactUsComponent implements OnInit {
  publicIp = "";
  contactForm: FormGroup;
  contactData = new ContactForm();
  buttonValidate: boolean;
  userId = "";
  title: string = 'Ecosystm Advisory Pte Ltd';
  lat: number = 1.277589;
  lng: number = 103.8413683;
  constructor(
    private rolesSharedService: RolesSharedService,
    private formBuilder: FormBuilder,
    @Inject(DOCUMENT) private document: Document
  ) {
    this.document.body.classList.add("inner-page");
    this.document.body.classList.remove("outer-page");
   // window.scroll(0, 0);
  }

  ngOnInit() {
    if (window.sessionStorage.getItem("userDetails") != null && window.sessionStorage.getItem("userDetails") != "null") {
      this.userId = JSON.parse(
        window.sessionStorage.getItem("userDetails")
      ).userId;
    }
    this.rolesSharedService.getPublicIp().subscribe(
      (response: any) => {
        this.publicIp = response.json().ip;
      },
      error => { }
    );
    this.createForm();
  }

  createForm() {
    this.contactForm = this.formBuilder.group({
      email: [
        "",
        [Validators.required, Validators.pattern(Constants.emailRegex)]
      ],
      firstName: [
        "",
        [
          Validators.required,
          Validators.pattern(Constants.firstNameRegex),
          Validators.minLength(3),
          Validators.maxLength(30)
        ]
      ],
      lastName: [
        "",
        [Validators.required, Validators.pattern(Constants.firstNameRegex)]
      ],
      message: ["", [Validators.required]]
    });
  }

  submitData() {
    if (this.contactForm.valid) {

      this.contactData.ipAddress = this.publicIp || "127.0.1.28";
      this.rolesSharedService.contactUsData(this.contactData).subscribe(
        response => {

          swal("Great", "We'll get back to you.", "success");
          this.contactForm.reset();
        },
        error => {

          swal("Info", error.error.error.message, "info");
        }
      );
    } else {
      this.buttonValidate = true;
      this.validateAllFormFields(this.contactForm);
    }
  }

  validateAllFormFields(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {
        this.validateAllFormFields(control);
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/feature/main/roles-shared/components/contact-us/contact-us.component.ts